(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('transactionsArching', {
                parent: 'app',
                url: '/transactionsArching',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactionsArching/transactionsArching.html',
                        controller: 'transactionsArchingController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLuggageTransaction('luggageUserTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'user';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            });
    }
})();
